<template>
    <b-modal ref="createGoal" id="createGoal" size="lg" @show="onShow" top :title="$t(postTitle)">

        <b-row class="mt-2">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                {{this.$t('dataTypeColumn')}}
            </b-col>
            <b-col>
                <b-form-select 
                v-model="selectedGoal.dataTypeId.editedValue" 
                @change="configureItemOnDataTypeChange($event, goal)"
                :options="allDataTypes"
                :disabled="inProgress || removingProcess"
                :class="Object.assign({'is-invalid':formGroupInput1Warn})">
                <option :value="null" disabled>{{ $t('choose-data-type') }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                {{this.$t('startYearColumn')}}
            </b-col>
            <b-col>
                <b-form-select 
                v-model="selectedGoal.startYear.editedValue" 
                :options="yearChoices.startYearChoices" 
                @change="setSelectedBaseYear($event)" style="border-radius: unset !important; height: 100%;"
                :disabled="inProgress || removingProcess"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                {{this.$t('endYearColumn')}}
            </b-col>
            <b-col>
                <b-form-select 
                v-model="selectedGoal.endYear.editedValue" 
                :options="yearChoices.endYearChoices" 
                @change="setSelectedEndYear($event)" style="border-radius: unset !important; height: 100%;"
                :disabled="inProgress || removingProcess"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                {{this.$t('goalTypeColumn')}}
            </b-col>
            <b-col>
                <b-form-select 
                    v-model="selectedGoal.direction.editedValue"
                    :disabled="inProgress || removingProcess">
                    <option :value="0">{{ $t('currentSituation') }}</option>
                    <option :value="-1">{{ $t('decrease') }}</option>
                    <option :value="1">{{ $t('raise') }}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                {{this.$t('goalRatioColumn')}}
            </b-col>
            <b-col>
                <masked-input
                    v-model="selectedGoal.valueR.editedValue"
                    :keepCharPositions="false"
                    :pipe="pipeNumber()"
                    type="text"
                    :mask="maskOfNumber"
                    :placeholder="$t('goalRatioColumn')"
                    :class="Object.assign(selectedGoal['valueR'].classes, {'masked-input-custom': true})"
                    @focus="resetWarning('valueR'); selectedGoal.lockR = false;"
                    :disabled="inProgress || removingProcess">
                </masked-input>

            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="3">
                {{this.$t('Location')}}
            </b-col>
            <b-col style="text-align: left;font-weight: bold">
                <div :style="formGroupInput2Warn">
                    <site-multi-select-tree
                        :givenSites="allSites"
                        :givenSelectedSites="getSelectedSiteIds()"
                        @oninput="selectSite"
                        :disabled="inProgress || removingProcess"
                        />
                </div>
            </b-col>
        </b-row>

        
        <div slot="modal-footer">
            <template v-if="inProgress">
                <div style="color:#ff0000;">
                    {{ this.$t('longProcessNotification') }}
                </div>
            </template>
            <template v-else-if="removingProcess">
                <div style="display:inline-block;width:100%;">
                    <span style="color:#ff0000;align:left;"> {{ this.$t('goal-deletion-warn') }} </span>
                    <b-button v-b-modal.warn v-b-tooltip.hover @click="deleteGoal()" :disabled="inProgress" variant="danger">{{ $t('yes') }}</b-button>
                    <b-button v-b-tooltip.hover @click="removingProcess = !removingProcess" :disabled="inProgress" variant="secondary">{{ $t('no') }}</b-button>
                </div>
            </template>
            <template v-else-if="type === 'updateGoal'">
                <b-button v-b-tooltip.hover @click="update()" :disabled="inProgress" variant="primary">{{ $t('save') }}</b-button>
                <b-button v-b-tooltip.hover @click="cancel()" :disabled="inProgress" variant="secondary">{{ $t('cancel') }}</b-button>
                <b-button v-b-modal.warn v-b-tooltip.hover @click="removingProcess = !removingProcess" :disabled="inProgress" variant="danger">{{ $t('delete') }}</b-button>
            </template>
            <template v-else>
                <b-button v-b-tooltip.hover @click="insert()" :disabled="inProgress" variant="primary">{{ $t('save') }}</b-button>
                <b-button v-b-tooltip.hover @click="cancel()" :disabled="inProgress" variant="danger">{{ $t('cancel') }}</b-button>
            </template>
        </div>
    </b-modal>
</template>

<script>
import SiteMultiSelectTree from '../SiteMultiSelectTree.vue';
import _ from 'lodash';

export default {
  components: { SiteMultiSelectTree },
    name: 'createGoal',
    data() {
        return {
            formGroupInput1Warn:false,
            formGroupInput2Warn:{},
            eventId: null,
            type: null,
            postTitle: null,
            selectedGoal: null,
            allSites: [],
            selectedTypeId: null,
            baseYear: null,
            targetYear: null,
            targetType: null,
            targetValue: 0,
            allDataTypes: null,
            inProgress: false,
            removingProcess: false,
            yearChoices: {
                startYearChoices: [
                    {
                        value: `${new Date().getFullYear() - 5}`,
                        text: `${new Date().getFullYear() - 5}`
                    },
                    {
                        value: `${new Date().getFullYear() - 4}`,
                        text: `${new Date().getFullYear() - 4}`
                    },
                    {
                        value: `${new Date().getFullYear() - 3}`,
                        text: `${new Date().getFullYear() - 3}`
                    },
                    {
                        value: `${new Date().getFullYear() - 2}`,
                        text: `${new Date().getFullYear() - 2}`
                    },
                    {
                        value: `${new Date().getFullYear() - 1}`,
                        text: `${new Date().getFullYear() - 1}`
                    }
                ],
                endYearChoices: [
                    {
                        value: `${new Date().getFullYear()}`,
                        text: `${new Date().getFullYear()}`
                    },
                    {
                        value: `${new Date().getFullYear() + 1}`,
                        text: `${new Date().getFullYear() + 1}`
                    },
                    {
                        value: `${new Date().getFullYear() + 2}`,
                        text: `${new Date().getFullYear() + 2}`
                    },
                    {
                        value: `${new Date().getFullYear() + 3}`,
                        text: `${new Date().getFullYear() + 3}`
                    },
                    {
                        value: `${new Date().getFullYear() + 4}`,
                        text: `${new Date().getFullYear() + 4}`
                    },
                    {
                        value: `${new Date().getFullYear() + 5}`,
                        text: `${new Date().getFullYear() + 5}`
                    }
                ]
            },
        };
    },
    filters: {
        toRatio(dividend, divider) {
            return divider ? (dividend / divider * 100).toFixed(0) : '-';
        },
        descriptionValueToText(val, descriptions) {
            return _.find(descriptions, {id: val}).description_text;
        },
        textToShortText(val) {
            if (val && val.length > 25) {
                return `${val.slice(0, 25)}...`;
            } else {
                return val;
            }
        }
    },
    methods: {
        getSelectedSiteIds(){
            return this.selectedGoal.goalSites.editedValue;
        },
        cancel(){
            let result = {process:'reset', id:this.selectedGoal.id}
            this.$eventHub.$emit(this.$store.state.modal.eventId, result);
            this.closeModal();
        },
        closeModal() {
            //this.onShow();
            this.$refs.createGoal.hide();
        },
        insert() {
            if (this.isValidInsertion() && !this.inProgress) {
                let selectedSiteIds = this.getSiteIdsInGroupedSitesMap(this.selectedGoal.goalSites.editedValue);
                let arrangedItem = {
                    startYear: this.selectedGoal.startYear.editedValue,
                    endYear: this.selectedGoal.endYear.editedValue,
                    siteId: _.head(selectedSiteIds),
                    dataTypeId: this.selectedGoal.dataTypeId.editedValue,
                    direction: this.selectedGoal.direction.editedValue,
                    sites: selectedSiteIds,
                    valueR: Number(
                        this.delocalizeValue(this.selectedGoal.valueR.editedValue, this.locale)
                            .replace('.', '')
                            .replace(',', '.')
                    ),
                    typeUnitId: 1,
                    isGlobal: 1
                };
                
                this.$Progress.start();
                this.inProgress = true;
                return this.axios
                    .post('/globalGoals', arrangedItem, {timeout:6000000})
                    .then(({data}) => {
                        let result = data;
                        result['sites'] = selectedSiteIds;
                        result['process'] = 'insert';
                        this.$eventHub.$emit(this.$store.state.modal.eventId, result);
                        this.inProgress = false;
                        return this.$Progress.finish();
                    }).then(()=>this.closeModal())
                    .catch(err => {
                        this.err = err;
                        this.showErrorNotification();
                    })


            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        update() {
            if (this.isValidInsertion() && !this.inProgress) {
                let selectedSiteIds = this.getSiteIdsInGroupedSitesMap(this.selectedGoal.goalSites.editedValue);
                let arrangedItem = {
                    startYear: this.selectedGoal.startYear.editedValue,
                    endYear: this.selectedGoal.endYear.editedValue,
                    dataTypeId: this.selectedGoal.dataTypeId.editedValue,
                    direction: this.selectedGoal.direction.editedValue,
                    sites: {
                        old: this.selectedGoal.goalSites.value,
                        new: selectedSiteIds
                    },
                    parentSiteId: this.selectedGoal.parentSiteId,
                    valueR: Number(
                        this.delocalizeValue(this.selectedGoal.valueR.editedValue, this.locale)
                            .replace('.', '')
                            .replace(',', '.')
                    ),
                    typeUnitId: 1,
                    isGlobal: 1
                };

                this.$Progress.start();
                this.inProgress = true;
                return this.axios.put(`/globalGoals/${this.selectedGoal.id}`, arrangedItem).then(({data}) => {
                    let result = data;
                    result['sites'] = selectedSiteIds;
                    result['process'] = 'update';
                    this.$eventHub.$emit(this.$store.state.modal.eventId, result);
                    this.inProgress = false;
                    return this.$Progress.finish();
                }).then(()=>this.closeModal());


            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        deleteGoal(){
            this.$Progress.start();
            this.inProgress = true;
            this.axios.delete(`/globalGoals/${this.selectedGoal.id}`)
                .then(()=>{
                    let result = {process:'delete', id:this.selectedGoal.id}
                    this.$eventHub.$emit(this.$store.state.modal.eventId, result);
                    this.inProgress = false;
                    this.removingProcess = false;
                    return this.$Progress.finish();
                }).then(()=>this.closeModal())
                .catch(() => {
                    this.showErrorNotification('deletion-failed');
                });
            /*
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
            });
            */
        },
        configureItemOnDataTypeChange() {
            return this.$nextTick().then(() => {
                let elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        isValidInsertion(){

            let isValid = true;

            if (_.isNil(this.selectedGoal.dataTypeId.editedValue)) {
                //this.selectedGoal.dataTypeId.classes['is-invalid'] = true;
                //this.selectedGoal.dataTypeId.hasWarn = true;
                this.formGroupInput1Warn = true;
                isValid = false;
            }
            else{
                this.formGroupInput1Warn = false;
                //this.selectedGoal.dataTypeId.classes['is-invalid'] = false;
                //this.selectedGoal.dataTypeId.hasWarn = false;
            }

            if(_.isNil(this.selectedGoal.goalSites.editedValue) || this.selectedGoal.goalSites.editedValue.length == 0){
                //this.selectedGoal.goalSites.classes['is-invalid'] = true;
                //this.selectedGoal.goalSites.hasWarn = true;
                this.formGroupInput2Warn = {'width':'100%','border':'1px solid #ff0000'};
                isValid = false;
            }
            else{
                this.formGroupInput2Warn = {};
                //this.selectedGoal.goalSites.classes['is-invalid'] = false;
                //this.selectedGoal.goalSites.hasWarn = false;
            }
            return isValid;

        },
        onShow(){
            Object.assign(this.$data, this.$options.data());
            this.eventId = this.$store.state.modal.eventId;
            this.type = this.$store.state.modal.type;
            this.postTitle = this.$store.state.modal.payload.title;
            this.allSites = this.$store.state.modal.payload.allSites;
            this.allDataTypes = this.$store.state.modal.payload.allDataTypes;
            


            if (this.type === 'createGoal') {
                this.selectedGoal = {
                    startYear: {editedValue: `${new Date().getFullYear() - 1}`},
                    endYear: {editedValue: `${new Date().getFullYear()}`},
                    direction: {editedValue: 0},
                    dataTypeId: {editedValue: null},
                    valueR: {editedValue: '0'},
                    goalSites: {editedValue: []},
                    unitName: ''
                };

                for (let key in this.selectedGoal) {
                    if (typeof this.selectedGoal[key] === 'object') {
                        this.selectedGoal[key].required = true;
                        this.selectedGoal[key].hasWarn = false;
                        this.selectedGoal[key].lockR = false; 
                        this.selectedGoal[key].classes = {
                            'is-invalid': false,
                            'form-control': true
                        };
                        this.selectedGoal[key].warnMessage = this.$t('required');
                    }
                }

            }
            else{
                this.selectedGoal = this.$store.state.modal.payload.selectedGoal;
            }
        },
        selectSite(value){
            this.selectedGoal.goalSites.editedValue = value;
        },
        setSelectedBaseYear(val) {
            this.selectedGoal.startYear.editedValue = val;
        },
        setSelectedEndYear(val) {
            this.selectedGoal.endYear.editedValue = val;
        },
        pipeNumber() {
            return conformedValue => {
                if (this.selectedGoal.direction.editedValue === -1) {
                    let unlocalizedConformedValue = Number(
                        this.delocalizeValue(this.selectedGoal.valueR.editedValue, this.locale)
                    );
                    return unlocalizedConformedValue > 100 ? '100' : conformedValue;
                } else {
                    return conformedValue;
                }
            };
        },
        resetWarning(key) {
            this.selectedGoal[key].classes['is-invalid'] = false;
            this.selectedGoal[key].hasWarn = false;
        },
        init(){
            this.onShow();
            //this.allSites = this.sitesWithGroups;
        }
    },
    computed: {
    },
    created(){
        this.init();
    }
};
</script>

<style scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
    "tr": {
    "postTitle": "HEDEFLER",
    "dataTypeColumn": "Veri Tipi",
    "startYearColumn": "Baz Yıl",
    "endYearColumn": "Hedef Yıl",
    "goalTypeColumn": "Hedef Tipi",
    "goalRatioColumn": "Hedeflenen (%)",
    "currentSituation": "Mevcut Durumu Koruma",
    "decrease": "Azaltma",
    "raise": "Arttırma",
    "longProcessNotification": "Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir.",
    "choose-data-type": "Veri tipi seç",
    "deletion-failed": "Silme işlemi gerçekleştirilemedi, tekrar deneyin.",
    "yes": "Evet",
    "no": "Hayır",
    "goal-deletion-warn": "Seçili global hedefi kalıcı olarak silmek istediğinizden emin misiniz?",
    "createGlobalGoal": "Global Hedef Oluştur",
    "updateGlobalGoal": "Global Hedefi Güncelle"
    
    },
    "en": {
    "postTitle": "GOALS",
    "dataTypeColumn": "Data Type",
    "startYearColumn": "Base Year",
    "endYearColumn": "Target Year",
    "goalTypeColumn": "Goal Type",
    "goalRatioColumn": "Targeted (%)",
    "currentSituation": "No Change",
    "decrease": "Decrease",
    "raise": "Raise",
    "longProcessNotification": "This process may take some time, please wait. When the process is complete, the table will be refreshed automatically.",
    "choose-data-type": "Choose data type",
    "deletion-failed": "Deletion failed, try again.",
    "yes": "Yes",
    "no": "No",
    "goal-deletion-warn": "Are you sure you want to permanently delete the selected global target?",
    "createGlobalGoal": "Create Global Goal",
    "updateGlobalGoal": "Update Global Goal"
    }
    }
</i18n>


// WEBPACK FOOTER //
// src/components/modals/CreateGoal.vue